import { useQuery } from 'react-query';
import { ApiServiceLink, claimLinkApi } from '../../../apis';
import { linkValidationErrors } from '../../claims/link/LinkValidation';
import { TRY_AGAIN } from '../../../common/exception/ErrorMessages';
import { LanguageType } from '../../../locale/locale';
import { getLanguageEnumFromType } from '../../../locale/languageMap';
import * as Sentry from '@sentry/react';

const initializePartnerClaim = async (name: string, language: LanguageType | undefined) => {
  const apiServiceLink: ApiServiceLink = {
    name,
    language: language && getLanguageEnumFromType(language),
  };
  try {
    return await claimLinkApi.initializeClaimFromServiceLink({
      apiServiceLink,
    });
  } catch (error) {
    if (error.status === 404) {
      throw new Error(linkValidationErrors.INVALID_LINK);
    } else {
      Sentry.captureException(error);
      throw new Error(TRY_AGAIN);
    }
  }
};

export const useClaimPartnerInitialization = (
  name: string,
  language: LanguageType | undefined
): any => {
  return useQuery('initializePartnerClaim', () => initializePartnerClaim(name, language), {
    retry: false,
  });
};
